const options = {
    // pdfUrl: 'https://mozilla.github.io/pdf.js/web/compressed.tracemonkey-pldi-09.pdf'
    pdfUrl: window.catalog_pdf_url,
    sound: false,
    autoplayLoop: false,
    btnShareIfMobile: true,
    btnBookmark: {
        enabled: false,
    },
    btnSound: {
        enabled: false,
    },
    // btn labels
    currentPage: {
        title: 'Página atual',
    },
    btnFirst: {
        title: 'Primeira página',
    },
    btnPrev: {
        title: 'Página anterior',
    },
    btnNext: {
        title: 'Próxima página',
    },
    btnLast: {
        title: 'Última página',
    },
    btnZoomIn: {
        title: 'Aumentar zoom',
    },
    btnZoomOut: {
        title: 'Diminuir zoom',
    },
    btnAutoplay: {
        title: 'Play automático',
    },
    btnSelect: {
        title: 'Selecionar página',
    },
    btnToc: {
        title: 'Índice',
    },
    btnThumbs: {
        title: 'Páginas',
    },
    btnShare: {
        title: 'Compartilhar',
    },
    btnPrint: {
        title: 'Imprimir',
    },
    btnExpand: {
        title: 'Tela Cheia',
    },
    btnClose: {
        title: 'Fechar',
    }
}
const container = document.getElementById('flipbook-container');

new FlipBook(container, options);